import { defineMessages } from "../i18n/core";

export const resetMessages = defineMessages({
  "pt-BR": {
    forgot: "Esqueci a senha",
    requestTitle: "Redefinir a senha",
    requestLede: "Informe o e-mail da sua conta. Se ele existir, enviamos um link válido por 30 minutos.",
    email: "E-mail",
    send: "Enviar link",
    sent: "Se houver uma conta com este e-mail, o link já está a caminho. Confira também a caixa de spam.",
    confirmTitle: "Escolha uma nova senha",
    confirmLede: "Para confirmar que é você, digite também o código do aplicativo autenticador. Todas as sessões abertas serão encerradas.",
    newPassword: "Nova senha",
    newPasswordHint: "De 12 a 256 caracteres. Uma frase longa é mais segura que uma senha curta complicada.",
    confirmPassword: "Repita a nova senha",
    mismatch: "As senhas não conferem.",
    code: "Código do autenticador",
    save: "Redefinir e entrar",
    done: "Senha redefinida. Entre com a nova senha.",
    lostAuthenticator: "Perdeu o aplicativo autenticador? Peça a um administrador da sua organização para redefinir a sua verificação em duas etapas.",
    backToLogin: "Voltar para a entrada",
    working: "Aguarde…",
    failed: "Não foi possível concluir. Tente de novo.",
  },
  "en-US": {
    forgot: "Forgot password",
    requestTitle: "Reset your password",
    requestLede: "Enter your account email. If it exists, we send a link valid for 30 minutes.",
    email: "Email",
    send: "Send link",
    sent: "If there is an account with this email, the link is on its way. Also check your spam folder.",
    confirmTitle: "Choose a new password",
    confirmLede: "To confirm it is you, also enter the code from your authenticator app. All open sessions will be signed out.",
    newPassword: "New password",
    newPasswordHint: "12 to 256 characters. A long passphrase is safer than a short complicated password.",
    confirmPassword: "Repeat the new password",
    mismatch: "The passwords do not match.",
    code: "Authenticator code",
    save: "Reset and sign in",
    done: "Password reset. Sign in with the new password.",
    lostAuthenticator: "Lost your authenticator app? Ask an administrator of your organization to reset your two-step verification.",
    backToLogin: "Back to sign in",
    working: "Please wait…",
    failed: "Could not complete. Try again.",
  },
  es: {
    forgot: "Olvidé mi contraseña",
    requestTitle: "Restablecer la contraseña",
    requestLede: "Indica el correo de tu cuenta. Si existe, enviamos un enlace válido por 30 minutos.",
    email: "Correo electrónico",
    send: "Enviar enlace",
    sent: "Si hay una cuenta con este correo, el enlace ya va en camino. Revisa también la carpeta de spam.",
    confirmTitle: "Elige una nueva contraseña",
    confirmLede: "Para confirmar que eres tú, escribe también el código de tu app de autenticación. Se cerrarán todas las sesiones abiertas.",
    newPassword: "Nueva contraseña",
    newPasswordHint: "De 12 a 256 caracteres. Una frase larga es más segura que una contraseña corta y complicada.",
    confirmPassword: "Repite la nueva contraseña",
    mismatch: "Las contraseñas no coinciden.",
    code: "Código de la app de autenticación",
    save: "Restablecer e iniciar sesión",
    done: "Contraseña restablecida. Inicia sesión con la nueva contraseña.",
    lostAuthenticator: "¿Perdiste tu app de autenticación? Pide a un administrador de tu organización que restablezca tu verificación en dos pasos.",
    backToLogin: "Volver a iniciar sesión",
    working: "Espera…",
    failed: "No se pudo completar. Inténtalo de nuevo.",
  },
});
